"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_comment_dots_orange_png_1 = __importDefault(require("images/sprites/ui/icons_comment_dots_orange.png"));
var Header = function (props) { return (react_1.default.createElement("div", { className: "unreadRequestWindow-Header unreadRequestWindow-Header-alignSpaceBetween" },
    react_1.default.createElement("i", { className: "fa fa-angle-left unreadRequestWindow-Header_BackIcon", onClick: props.onClickLeftAngle }),
    react_1.default.createElement("span", { className: "unreadRequestWindow-Header_StoreName" }, props.store.name),
    react_1.default.createElement("div", { className: "unreadRequestWindow-Header_CommentButtonWrapper" },
        react_1.default.createElement("img", { src: icons_comment_dots_orange_png_1.default, alt: "", className: "unreadRequestWindow-Header_CommentIcon lazyload" }),
        react_1.default.createElement("span", { className: "unreadRequestWindow-Header_CommentButtonText" }, "\u30E1\u30C3\u30BB\u30FC\u30B8")))); };
exports.default = Header;
